import { ReactNode } from "react"
import { useNavigate } from "react-router-dom"
import { useAppSelector } from "../../redux/hooks"
import { GenericSpinner } from "../GenericSpinner/GenericSpinner"
import { Box, Button, Typography } from "@mui/material"

interface MembersRouteProps {
    children?: ReactNode
}

export const MembersRoute = ({ children }: MembersRouteProps) => {
    const auth = useAppSelector(state => state.auth)
    const navigate = useNavigate()

    if (auth.pending) {
        return <GenericSpinner />
    }

    if (!auth.data) {
        navigate('/auth/sign-in')
        return <></>
    }

    if (!auth.idTokenPayload?.["cognito:groups"]?.includes('member') &&
        !auth.idTokenPayload?.["cognito:groups"]?.includes('superadmin') &&
        !auth.idTokenPayload?.["cognito:groups"]?.includes('admin')
    ) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', mt: 3 }}>
            <Typography variant='h3' sx={{ fontSize: '1.5rem', fontWeight: 400, }}>
                Whoops!
            </Typography>
            <Typography variant='body1' sx={{ fontSize: '1rem', fontWeight: 200, mt: 3 }}>
                It looks like you don't have access to do that. If you think this is a mistake, please contact an administrator.
            </Typography>
            <Button
                variant='contained'
                sx={{ mt: 3 }}
                onClick={() => navigate('/')}
            >
                Return Home
            </Button>
        </Box>
    }

    return children
}